<template>
  <button
    class="icon-favorite"
    :class="{
      active: !!active
    }"
    @click="$emit('click')"
  >
    <keep-alive>
      <InlineSvg
        v-if="active"
        class="favorite-icon"
        :width="width"
        :color="color"
        icon="~public/images/inline/theme-favorite-active.svg"
      />
      <InlineSvg
        v-else
        class="favorite-icon"
        :width="width"
        :color="color"
        icon="~public/images/inline/theme-favorite.svg"
      />
    </keep-alive>
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: [Boolean, Number],
      default: false
    },
    width: {
      type: String,
      default: '13px'
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-favorite {
  display: inline-block;
  line-height: 0;

  .favorite-icon {
    width: 14px;
    height: 14px;
    color: #999;
  }

  &:active {
    .favorite-icon {
      color: #ccc;
    }
  }

  &.active {
    .inline-svg {
      color: #ffca27;
    }

    &:active {
      .inline-svg {
        color: #ffdf7d;
      }
    }
  }
}
</style>
